import { Select, type SelectOption } from '@shared/ui/select';

import { SECTOR_LABEL, type SectorOption } from '../model/portfolio';

export interface SectorSelectProps {
  value: SectorOption | null;
  onChange: (value: SectorOption) => void;
  invalid?: boolean;
  disabled?: boolean;
  placeholder?: string;
  /** Select 로 넘긴다(목록을 제자리에 그리기) */
  inline?: boolean;
  className?: string;
  id?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  'aria-describedby'?: string;
}

const SECTOR_OPTIONS: SelectOption[] = Object.entries(SECTOR_LABEL).map(([value, label]) => ({
  value,
  label,
}));

/**
 * Select atom 에 섹터 선택지를 넣은 것(atom 사용 예 — 컴포넌트 아님, DD-12 G3 · G9).
 * 너비는 놓이는 자리를 채운다(폼 줄에서는 200).
 */
export function SectorSelect({ onChange, ...rest }: SectorSelectProps) {
  return (
    <Select
      {...rest}
      options={SECTOR_OPTIONS}
      // 선택지는 SECTOR_LABEL 의 키만 담는다
      onChange={(next) => onChange(next as SectorOption)}
    />
  );
}
